var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloseRounded(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "close-rounded") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18,0C8.1,0,0,8.1,0,18s8.1,18,18,18c9.9,0,18-8.1,18-18S27.9,0,18,0z M18,33.6c-8.6,0-15.6-7-15.6-15.6S9.4,2.4,18,2.4 s15.6,7,15.6,15.6S26.6,33.6,18,33.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6,10.4c-0.5-0.5-1.2-0.5-1.7,0L18,16.3l-5.9-5.9c-0.5-0.5-1.2-0.5-1.7,0s-0.5,1.2,0,1.7l5.9,5.9l-5.9,5.9 c-0.5,0.5-0.5,1.2,0,1.7c0.2,0.2,0.5,0.4,0.8,0.4s0.6-0.1,0.8-0.4l5.9-5.9l5.9,5.9c0.2,0.2,0.5,0.4,0.8,0.4s0.6-0.1,0.8-0.4 c0.5-0.5,0.5-1.2,0-1.7L19.7,18l5.9-5.9C26.1,11.6,26.1,10.9,25.6,10.4z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseRounded);
export default __webpack_public_path__ + "static/media/close-rounded.91e38193.svg";
export { ForwardRef as ReactComponent };